import * as React from 'react';
import { Fade, Collapse } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import cn from 'classnames';
import { SearchForm } from '@websky/core/src';
import { ThemeProvider, useTheme } from '@websky/core/src/theme';
import { initI18n, MOBILE_MIN_WIDTH } from '@websky/core/src/utils';
import MediaQuery from '@websky/core/src/MediaQuery/MediaQuery';
import Tabs from '@websky/core/src/Tabs/Tabs';
import Checkin from './Checkin/Checkin';
import Booking from './Booking/Booking';
import { useFormsContext } from './context';
import css from './Forms.css';
initI18n('Forms');
const Forms = () => {
    const { t } = useTranslation('Forms');
    const theme = useTheme('Forms').Forms;
    const [tab, setTab] = React.useState(0);
    const { isMultiCity } = useFormsContext();
    const tabs = [
        {
            header: t('Search'),
            value: 0
        },
        {
            header: t('My booking'),
            value: 2
        },
        {
            header: t('Checkin'),
            value: 1
        }
    ];
    const formsTheme = {
        Forms: {
            Field: {
                input__wrapper: css.input__wrapper,
                label: css.label,
                label_shrink: css.label_shrink,
                input__inner: css.input__inner
            }
        },
        Tooltip: {
            Tooltip: {
                tooltip: css.tooltip
            }
        }
    };
    const isMobile = useMediaQuery({ maxWidth: MOBILE_MIN_WIDTH });
    return (React.createElement(ThemeProvider, { value: formsTheme },
        React.createElement("div", { className: css.container },
            React.createElement(MediaQuery, { minWidth: "mobile" },
                React.createElement(Collapse, { in: !isMultiCity, mountOnEnter: true, unmountOnExit: true },
                    React.createElement("div", { className: cn(css.tabs, { [css.tabs_hidden]: isMultiCity }) },
                        React.createElement(Tabs, { tabs: tabs, onChange: setTab, selected: tab, className: theme.tabs, tabHeaderClassName: theme.tabLabel, selectedTabClassName: theme.tabSelected, indicatorClassName: theme.indicator, rootTabsClassName: theme.tabs__container, variant: isMobile ? 'scrollable' : 'standard' })))),
            React.createElement(MediaQuery, { maxWidth: "mobile" },
                React.createElement("div", { className: css.tabs },
                    React.createElement(Tabs, { tabs: tabs, onChange: setTab, selected: tab, className: theme.tabs, tabHeaderClassName: theme.tabLabel, selectedTabClassName: theme.tabSelected, indicatorClassName: theme.indicator, rootTabsClassName: theme.tabs__container, variant: isMobile ? 'scrollable' : 'standard' }))),
            React.createElement("div", { className: css.content },
                tab === 0 && (React.createElement(Fade, { in: tab === 0 },
                    React.createElement("div", { className: theme.container },
                        React.createElement(SearchForm, null)))),
                tab === 1 && (React.createElement(Fade, { in: tab === 1 },
                    React.createElement("div", { className: theme.container },
                        React.createElement(Checkin, null)))),
                tab === 2 && (React.createElement(Fade, { in: tab === 2 },
                    React.createElement("div", { className: theme.container },
                        React.createElement(Booking, null))))))));
};
export default Forms;
